

const Freeze = (state = { hasFutureFreeze: false, isFrozen: false, freezes: null }, action) => {
  switch (action.type) {
    case 'SET_FREEZES':
      return {
        ...state,
        freezes: action.freezes,
      };
    case 'SET_FREEZE_STATUS':
      return {
        ...state,
        hasFutureFreeze: action.hasFutureFreeze,
        isFrozen: action.isFrozen,
      };
    default:
      return state;
  }
};

export default Freeze;



// WEBPACK FOOTER //
// ./src/reducers/FreezeReducer.js